import React, { FC } from 'react';

import CircularProgress from '@u4i/common/CircularProgress';

export const ScormAuthentication: FC = () => (
  <CircularProgress />
);
